






























import breakpoints from 'library/assets/vars/breakpoints'
export default

	props: block: Object

	data: ->
		selectedGroup: 0
		loaded: false

		config:
			slidesPerPage: if @$route.name == 'products-product-variant' then 3 else 4
			showDots: true
			gutter: 'var(--gutter)'
			peekLeft: 'var(--gutter)'
			peekRight: 'var(--gutter)'
			responsive: [
				{
					minWidth: parseInt(breakpoints.desktop) + 1
					slidesPerPage: if @$route.name == 'products-product-variant' then 3 else 4
					feather: 'var(--gutter)'
				}
				{
					maxWidth: parseInt breakpoints['tablet-landscape']
					slidesPerPage: 3
				}
				{
					maxWidth: parseInt breakpoints.tablet
					slidesPerPage: 2
				}
				{
					maxWidth: parseInt breakpoints.mobile
					slidesPerPage: 1
				}
			]

	mounted: ->
		@$nextTick => @loaded = true

	computed:

		selectedCards: -> @block.cardGroups[@selectedGroup].cards
		isPdp: ->
			if @$route.name == 'products-product-variant' then return true
			else return false

		#max: -> if @isPdp then return 3 else return 4

	methods:
		navClick: (newIndex) -> @selectedGroup = newIndex

